<template>
  <div class="footer">
    <p class="d-lg-block">MijnVerenigingsWeb © {{new Date().getFullYear()}}</p>
    <!-- <ul class="d-flex  justify-content-between list-unstyled ml-4 mr-4 d-lg-none d-block pt-2">
            <li class="m-1" style="font-size: 10px">
                <router-link to="/home" class="text-black">
                    <div class="text-center"><img src="/assets/img/home_1.svg" style="height: 15px"></div>
                    Homepage
                </router-link>

            </li>

            <li class="m-1" style="font-size: 10px">
                <router-link to="/community/members" class="text-black">
                    <div class="text-center"> <img src="/assets/img/community.svg" style="height: 15px"></div>Vereniging</router-link>
                </li>

            <li class="m-1" style="font-size: 10px">
                <router-link to="/committees/all" class="text-black">
                    <div class="text-center">  <img src="/assets/img/handshake.svg" style="height: 15px"></div>Commissies</router-link>

                </li>

            <li class="m-1" style="font-size: 10px">
                <router-link to="/itemgroups" class="text-black">
                    <div class="text-center">  <img src="/assets/img/sitemap.svg" style="height: 15px"></div>Itemgroups</router-link>
                </li>
            <li class="m-1" style="font-size: 10px">
                <router-link to="/settings" class="text-black">
                    <div class="text-center">   <img src="/assets/img/Settings.svg" style="height: 15px" ></div>Instellingen</router-link>
                </li>
        </ul> -->
  </div>
</template>

<script>
export default {
  name: "foot",
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px -2px 10px #00000029;
  opacity: 1;
  text-align: center;
  z-index: 1028;
}
.footer p {
  margin-top: 1rem;
}
</style>
